import axios from 'axios';

const create = (data) => axios.post('/agendamentos', data);
const get = (id) => axios.get(`/agendamentos/${id}`);
const list = (params) => axios.get('/agendamentos', { params });
const update = (id, aluno) => axios.put(`/agendamentos/${id}`, aluno);
const remove = (id) => axios.delete(`/agendamentos/${id}`, {});
const save = (agendamento) => {
  if (agendamento.id) {
    return update(agendamento.id, agendamento);
  }
  return create(agendamento);
};

export default {
  create,
  get,
  list,
  update,
  save,
  remove,
};
